
import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CONFIG } from '../../config';
import { UtilsService } from '../../xform-compat';


@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private readonly emailCheckPath = `${CONFIG.apiUrl}/uaa/oidc/signin-redirect`;
  private readonly tokenPath = `${CONFIG.apiUrl}/uaa/token-proxy/token`;
  private readonly tokenExchangePath = `${CONFIG.apiUrl}/uaa/oidc/token-exchange`;
  private readonly checkTokenPath = `${CONFIG.apiUrl}/uaa/oauth/check_token`;
  private readonly logoutPath = `${CONFIG.apiUrl}/uaa/authorization/logout`;
  private readonly authInfo = CONFIG.oAuth.regular;
  private readonly authInfoTwoFactor = CONFIG.oAuth.twoFactor;
  private readonly refreshTokenInfo = CONFIG.oAuth.refreshToken;
  private headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

  constructor(
    private utilsService: UtilsService,
    private http: HttpClient
  ) {}

  public getLoginRedirectUrl(email: string) {
    const httpParams: HttpParams = this.utilsService.generateParams({
      username: email,
      appName: 'rms'
    });
    return this.http.get(this.emailCheckPath, {params: httpParams}).pipe(catchError(ex => {
throw ex;
}));
  }

  public login(credentials) {
    const data = new URLSearchParams();
    data.set('client_id', this.authInfo.clientId);
    data.set('client_secret', this.authInfo.clientSecret);
    data.set('username', credentials.username);
    data.set('password', credentials.password);

    if (!credentials.twoFactor) {
      data.set('grant_type', this.authInfo.grantType);
    } else {
      data.set('grant_type', this.authInfoTwoFactor.grantType);
      data.set('app_name', `${CONFIG.oAuth.twoFactor.appName}`);
      data.set('secret_code', credentials.secretCode);
    }

    return this.http.post(this.tokenPath, data.toString(), { headers: this.headers }).pipe(
      catchError(ex => {
 throw ex;
}));
  }

  /**
   * Service method to refresh user session info
   * @param {string} refreshToken: current logged user info
   * @returns {Observable<Object>}: Response from the request
   */
  public refreshToken (refreshToken: string) {
    const data = new HttpParams()
      .set('grant_type', this.refreshTokenInfo.grantType)
      .set('client_id', this.authInfo.clientId)
      .set('client_secret', this.authInfo.clientSecret)
      .set('refresh_token', refreshToken);

    return this.http.post(this.tokenPath, data);
  }

  /**
   * Exchanges an OIDC access token key for a full token pair (access + refresh).
   * @param key The access token received from the identity provider
   */
  public tokenExchange(key: string) {
    return this.http.post(this.tokenExchangePath, { key });
  }

  public logout() {
    return this.http.post(this.logoutPath, {}).pipe(
      catchError(ex => {
 throw ex;
}));
  }

  public validateToken(token) {
    const data = new HttpParams()
      .set('token', token);

    return this.http.post(this.checkTokenPath, data, { headers: this.headers }).pipe(
      catchError(ex => {
 throw ex;
}));
  }
}
